import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useCreateOrderMutation } from 'api/generated/graphql';
import { parseCreateOrderParams, useError } from 'api/helpers';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';
import { CreateOrderParams } from 'api/types/params';

export const useCreateOrder = () => {
  const notifyMessage = useNotifyMessages();

  const [createOrder, { loading, error: apolloError }] =
    useCreateOrderMutation();

  const error = useError(apolloError);

  return {
    createOrder: useCallback(
      async (params: CreateOrderParams) => {
        const input = parseCreateOrderParams(params);
        const res = await createOrder({
          variables: {
            input: {
              ...input,
            },
          },
        });
        if (res.data?.createOrder?.messages) {
          notifyMessage(res.data.createOrder.messages);
        }

        return res.data?.createOrder?.data.orderId;
      },
      [createOrder, notifyMessage]
    ),
    loading,
    error,
  };
};
